/**
 * Berkas Excel contoh Pendataan Awal (prototype v7.50 `assets/jal-contoh-excel.js`, `saldo-material.xlsx`): saldo material
 * dari prototipe client — 239 baris, empat di antaranya saldo 0 (supaya "baris saldo 0 dilewati" terlihat) dan sebagian
 * besar nama belum ada di Master Material. Dipakai tombol "Pakai File Contoh" (jalur impor yang SAMA dengan berkas
 * sungguhan), seed local mode, dan uji.
 */

export const PD_SAMPLE_FILE_NAME = 'saldo-material.xlsx'
export const PD_SAMPLE_SHEET = 'Sheet1'
export const PD_SAMPLE_HEADER = ['No', 'Nama Material', 'Saldo', 'Satuan'] as const

/** [no, nama material, saldo, satuan] */
export const PD_SAMPLE_ROWS: [number, string, number, string][] = [
  [1, 'Etiket bold 12 PR/PT', 655480, 'lembar'],
  [2, 'Etiket MBG 12', 198000, 'lembar'],
  [3, 'Etiket MBG 20', 198000, 'lembar'],
  [4, 'Etiket Milllions Menthol', 229000, 'lembar'],
  [5, 'Etiket Bold 20 Round Corner lokal (PT)', 282000, 'lembar'],
  [6, 'Etiket Next 20', 115000, 'lembar'],
  [7, 'Etiket Xtra 20 (PT)', 198000, 'lembar'],
  [8, 'Etiket Ben Laris', 24000, 'lembar'],
  [9, 'Etiket Nat 20 Reguler', 3300, 'lembar'],
  [10, 'ETIKET NATURAL 12 (PT)', 110280, 'lembar'],
  [11, 'Etiket eztu', 252000, 'lembar'],
  [12, 'Etiket tabaco mild premier', 500000, 'lembar'],
  [13, 'Etiket XX', 200000, 'lembar'],
  [14, 'Etiket orange mild20', 198000, 'lembar'],
  [15, 'Etiket Million Dlim', 128500, 'lembar'],
  [16, 'ETIKET AM SPOT UV (PT)', 122900, 'lembar'],
  [17, 'Etiket Xtra 12 PR', 269000, 'lembar'],
  [18, 'Etiket Kenzo', 99000, 'lembar'],
  [19, 'Etiket tabaco black', 2850, 'lembar'],
  [20, 'Etiket Kruz Merah new', 50000, 'lembar'],
  [21, 'Etiket Kruz Merah New Export', 32700, 'lembar'],
  [22, 'Etiket One New Export', 782500, 'lembar'],
  [23, 'Etiket Tabaco Brave', 25500, 'lembar'],
  [24, 'Etiket Brave export', 133300, 'lembar'],
  [25, 'Etiket Rasean', 250000, 'lembar'],
  [26, 'Etiket Mecheste Merah (export)', 1000, 'lembar'],
  [27, 'Etiket Mechaste Hijau (export)', 198000, 'lembar'],
  [28, 'ETIKET ZIRRO MILD 20 BLUEBERRY', 201700, 'lembar'],
  [29, 'ETIKET ZIRRO MILD 20 MENTHOL', 159200, 'lembar'],
  [30, 'ETIKET ZIRRO MILD COOLBERRY NEW (INDRAJAYA)', 780000, 'lembar'],
  [31, 'Etiket Tabaco One 12', 0, 'lembar'],
  [32, 'ETIKET MR 20 (PT)', 1199500, 'lembar'],
  [33, 'ETIKET RAIDER (PT)', 148750, 'lembar'],
  [34, 'ETIKET TABACO ONE 12 (PT)', 1416500, 'lembar'],
  [35, 'Etiket Bold 20 RC (Export)', 333750, 'lembar'],
  [36, 'Etiket Brighton Merah export (serat baru)', 11000, 'lembar'],
  [37, 'Etiket brighton menthol export(serat baru)', 10000, 'lembar'],
  [38, "Etiket D'taro", 88250, 'lembar'],
  [39, 'Etiket Millions Dlim (design baru)', 409500, 'lembar'],
  [40, 'ETIKET GUDANG GULO (EXP) SKM 12', 44000, 'lembar'],
  [41, 'ETIKET GEDONG GULO (LOKAL) SKM 12', 174260, 'lembar'],
  [42, 'ETIKET DAMEN (LOKAL) SKM 12', 15000, 'lembar'],
  [43, 'ETIKET NATURAL 20 (PT)', 107950, 'lembar'],
  [44, 'ETIKERT RAIDER (EXPORT)', 10350, 'lembar'],
  [45, 'ETIKET ROUNDED TABACO BRAVE REG', 2661000, 'lembar'],
  [46, 'ETIKET ROUNDED TABACO BRAVE EXPORT', 2746250, 'lembar'],
  [47, 'ETIKET ZIRRO MANGGA', 245000, 'lembar'],
  [48, 'ETIKET ZIRRO COFFE', 118250, 'lembar'],
  [49, 'ETIKET JLV EXPORT', 240000, 'lembar'],
  [50, 'CTP bold', 290, 'lembar'],
  [51, 'CTP Orange', 8, 'lembar'],
  [52, 'CTP MBG', 50, 'lembar'],
  [53, 'CTP Xtra', 454, 'lembar'],
  [54, 'CTP Million Dlim', 119, 'lembar'],
  [55, 'CTP Tabaco one12', 120, 'lembar'],
  [56, 'CTP eztu mild', 177, 'lembar'],
  [57, 'CTP MR', 1094, 'lembar'],
  [58, 'CTP Million Mild', 243, 'lembar'],
  [59, 'CTP Tabaco Premier', 248, 'lembar'],
  [60, 'CTP Raider Mild', 262, 'lembar'],
  [61, 'CTP Raider Reg', 29, 'lembar'],
  [62, 'CTP Tabaco Next(New)', 60, 'lembar'],
  [63, 'CTP Kruz merah', 34, 'lembar'],
  [64, 'CTP kruz putih', 38, 'lembar'],
  [65, 'CTP Rasean gold red', 93, 'lembar'],
  [66, 'CTP Tabaco Brave Non Lio Release', 9, 'lembar'],
  [67, 'CTP Kenzo Menthol', 10, 'lembar'],
  [68, 'CTP ZIRRO CLICK BOOST', 95, 'lembar'],
  [69, 'CTP ZIRRO BLUEBERRY CLICK BOOST MENTHOL', 66, 'lembar'],
  [70, 'CTP MECHESTE', 20, 'lembar'],
  [71, 'CTP Brighton reguler (yellow)', 27, 'lembar'],
  [72, 'CTP Brighton menthol (Green)', 22, 'lembar'],
  [73, 'CTP POLOS MENTHOL', 20, 'lembar'],
  [74, 'CTP SPM', 50, 'lembar'],
  [75, 'CTP ZIRRO BERRY COOL DENGAN FOIL SILVER', 114, 'lembar'],
  [76, 'CTP CLICK BOOST BERRY MINT', 44, 'lembar'],
  [77, 'CTP MILLIONS DENGAN GREEN FOIL', 100, 'lembar'],
  [78, 'CTP MILLIONS MENTHOL', 33, 'lembar'],
  [79, 'CTP MILLIONS RED', 15, 'lembar'],
  [80, 'CTP DAMEN', 20, 'lembar'],
  [81, 'CTP ZIRRO MANGGA', 46, 'lembar'],
  [82, 'CTP ZIRRO COFFE', 90, 'lembar'],
  [83, 'Inner Black 96', 206, 'roll'],
  [84, 'Inner Gold 96', 65, 'roll'],
  [85, 'Inner Putih 96', 55, 'roll'],
  [86, 'Inner Gold 87', 199, 'roll'],
  [87, 'Inner Black 87', 79, 'roll'],
  [88, 'Inner putih 87', 31, 'roll'],
  [89, 'Inner Gold 79', 19, 'roll'],
  [90, 'Inner Black 84', 50, 'roll'],
  [91, 'Inner Gold 91', 266, 'roll'],
  [92, 'Filter RG 120-780-SF13', 0, 'pcs'],
  [93, 'Inner Black 91', 60, 'roll'],
  [94, 'INNER PUTIH 91', 62, 'roll'],
  [95, 'Foil Black 86', 297, 'roll'],
  [96, 'Foil Gold 86', 20, 'roll'],
  [97, 'Foil red 86', 100, 'roll'],
  [98, 'Foil Black 76', 186, 'roll'],
  [99, 'Foil Gold 76', 293, 'roll'],
  [100, 'Foil Silver 76', 108, 'roll'],
  [101, 'Foil red 76', 55, 'roll'],
  [102, 'Foil Silver 86', 212, 'roll'],
  [103, 'FOIL SILVER 86 (BENING)', 77, 'roll'],
  [104, 'Foil gold 70', 139, 'roll'],
  [105, 'Foil Brown Uk.12,1 x 50', 15, 'roll'],
  [106, 'Foil Gold Uk.12,1 x 50', 3, 'roll'],
  [107, 'Foil Black Uk.12,1', 142, 'roll'],
  [108, 'Foil bright silver 128 core kecil', 476, 'roll'],
  [109, 'FOIL SILVER 128 (CORE BESAR)', 24, 'roll'],
  [110, 'Box polos reguler UK.580*380*460', 1333, 'pcs'],
  [111, 'Box polos mild UK.538*353*473', 2562, 'pcs'],
  [112, 'Box Tabaco One 12 Export', 1664, 'pcs'],
  [113, 'Box Xtra', 8528, 'pcs'],
  [114, 'Box Orange', 2710, 'pcs'],
  [115, 'Box Arum Manis', 1200, 'pcs'],
  [116, 'Box Natural Slim 20 (logo)', 1350, 'pcs'],
  [117, 'BOX MILLIONS TIMOR LESTE (450*235*565)', 200, 'pcs'],
  [118, 'Box Rasean Uk.465*240*570', 57, 'pcs'],
  [119, 'Box Zirro Blueberry', 950, 'pcs'],
  [120, 'Box Zirro Menthol', 7650, 'pcs'],
  [121, 'Box Mechaste Hijau', 100, 'pcs'],
  [122, 'BOX BRIGHTON MENTHOL', 1000, 'pcs'],
  [123, 'BOX MILLIONS MENTHOL', 1000, 'pcs'],
  [124, 'BOX MILLIONS MERAH', 1520, 'pcs'],
  [125, 'Bobin reguler', 987, 'roll'],
  [126, 'Bobin mild', 4533, 'roll'],
  [127, 'Bobin 27 merah (kruz)', 839, 'roll'],
  [128, 'Teartape transparant', 98, 'pcs'],
  [129, 'Teartape gold', 30, 'pcs'],
  [130, 'Teartape transparant hologram', 512, 'pcs'],
  [131, 'Teartape gold hologram', 4299, 'pcs'],
  [132, 'Lakban(dus)', 856, 'pcs'],
  [133, 'Opp 115*145 (kg)', 1088, 'roll'],
  [134, 'Opp 116', 155, 'roll'],
  [135, 'OPP 260', 2562, 'roll'],
  [136, 'Opp 300X360 (42 kg/dus)', 855, 'roll'],
  [137, 'Opp 285x360 (kg)', 1090, 'roll'],
  [138, 'Opp sbb22 350', 90, 'roll'],
  [139, 'OPP 125', 220, 'roll'],
  [140, 'Opp 110*125', 38, 'roll'],
  [141, 'Opp 115*195/TR (Khusus Natslim)/pack', 50, 'roll'],
  [142, 'Opp 115 (Roll)', 55, 'roll'],
  [143, 'Opp 330 (ASTRIA)', 224, 'roll'],
  [144, 'Opp 120', 247, 'roll'],
  [145, 'OPP 135', 135, 'roll'],
  [146, 'OPP 117', 6, 'roll'],
  [147, 'OPP 285 x 335 (kg)', 557, 'roll'],
  [148, 'Opp Roll 310', 91, 'roll'],
  [149, 'Opp Roll 132', 288, 'roll'],
  [150, 'Opp 280*335 (Kg)', 769, 'roll'],
  [151, 'OPP 265', 1170, 'roll'],
  [152, 'Kraft 75x100', 40, 'pcs'],
  [153, 'CTP Bold 5cm', 0, 'lembar'],
  [154, 'Dospress Kruz Merah New Export', 200, 'pcs'],
  [155, 'Dospress Rasean Mesin', 10000, 'pcs'],
  [156, 'Dospress Mecheste Merah', 600, 'pcs'],
  [157, 'Dospress Mechaste Hijau', 46250, 'pcs'],
  [158, 'Dosspres Brighton red (Lokal)', 36200, 'pcs'],
  [159, 'Dosspres Brighton blue (Lokal)', 21500, 'pcs'],
  [160, 'DOSPRESS BRIGHTON RED (PURA)', 121000, 'pcs'],
  [161, 'DOSPRESS BRIGHTON MENTHOL (PURA)', 76250, 'pcs'],
  [162, 'DOSPRESS MILLIONS RED (PURA)', 133000, 'pcs'],
  [163, 'DOSPRESS MILLIONS MENTHOL (PURA)', 555170, 'pcs'],
  [164, 'Papier Natural Slim kuning', 40, 'roll'],
  [165, 'Papir Natslim uk.81(boss)', 24, 'roll'],
  [166, 'Papir Tabaco pure natural (Baru)', 12, 'roll'],
  [167, 'Strapping Band', 25, 'pcs'],
  [168, 'FILTER MCB 804141 MENTHOL (TRAY)', 120, 'pcs'],
  [169, 'FILTER MCF 807726 NANO BERRY (TRAY)', 132, 'pcs'],
  [170, 'Segel Zirro', 1, 'pcs'],
  [171, 'Cigarette paper tabaco natural (ROLL)', 197, 'pcs'],
  [172, 'SOFTPACK CONRAD ORIGINAL', 50, 'pcs'],
  [173, 'SOFTPACK CONRAD MENTHOL', 50, 'pcs'],
  [174, 'OPP 350 AKRILIK', 20, 'roll'],
  [175, 'LEM CTP 8292 (kg)', 200, 'kg'],
  [176, 'PLASTIK WRAPP', 168, 'pcs'],
  [177, 'LEM CTP MOLLIN 8143 (kg)', 3400, 'kg'],
  [178, 'LEM HLP 5545 (kg)', 300, 'kg'],
  [179, 'PLASTIK CANNON "80"', 9400, 'pcs'],
  [180, 'LEM PAPIR MOLLIN 132-2056 (kg)', 820, 'kg'],
  [181, 'LAKBAN SECURRTY', 432, 'pcs'],
  [182, 'LEM BOS 8050 (kg)', 340, 'kg'],
  [183, 'ETIKET NATURAL 16 (PT)', 149950, 'lembar'],
  [184, 'BOBBIN SLIM UK 19*6000M', 90, 'roll'],
  [185, 'ETIKET MOS BLACK', 100000, 'lembar'],
  [186, 'CTP MOS BLACK', 66, 'lembar'],
  [187, 'ETIKET AMANA  16 (SKT)', 148200, 'lembar'],
  [188, 'ETIKET AMANA  12 (SKT)', 64385, 'lembar'],
  [189, 'FILTER MILD CAPSULE MENTHOL 65 % 100 X 6,95', 13, 'pcs'],
  [190, 'BOBIN MILD BLACK 24 X 6000 M', 10, 'roll'],
  [191, 'ETIKET AMANA 20 HLP SKM', 464250, 'lembar'],
  [192, 'ETIKET AMANA 12 HLP SKM', 322300, 'lembar'],
  [193, 'FOIL SILVER 12,1', 16, 'roll'],
  [194, 'DOSSPRESS MOS WHITE', 2500, 'pcs'],
  [195, 'CTP MOS WHITE BLUE', 17, 'lembar'],
  [196, 'LEM AQUANCE 8251', 290, 'kg'],
  [197, 'FOIL SIVER DOVE 121', 55, 'roll'],
  [198, 'BOX MOS BLACK uk 490*225*536 mm', 50, 'pcs'],
  [199, 'FOIL SILVER 121', 1, 'roll'],
  [200, 'Inner White 91 Core 121', 8, 'roll'],
  [201, 'MATTE MST CMP 128', 168, 'pcs'],
  [202, 'Etiket New Balmain', 47750, 'lembar'],
  [203, 'Plakball balmain', 88700, 'pcs'],
  [204, 'Etiket Bold hlp 10', 231000, 'lembar'],
  [205, 'CTP YELLOW TABACCO Uk 60mm', 64, 'lembar'],
  [206, 'CTP S BOLD uk 50 mm', 64, 'lembar'],
  [207, 'Etiket One Eksport 10', 100990, 'lembar'],
  [208, 'Etiket Amana mangga 16', 52896, 'lembar'],
  [209, 'ETIKET JAMAS COKLAT 12 SKT', 519384, 'lembar'],
  [210, 'Etiket S bold', 154990, 'lembar'],
  [211, 'INNER BLACK 70', 34, 'roll'],
  [212, 'INNER GOLD 70', 99, 'roll'],
  [213, 'FOIL GOLD 66', 5, 'roll'],
  [214, 'OPP Roll 640 Bening', 0, 'roll'],
  [215, 'ETIKET JAMAS HIJAU 12 SKT', 553676, 'lembar'],
  [216, 'etiket raider made in indonesia', 168000, 'lembar'],
  [217, 'ctp amini black uk 70', 100, 'lembar'],
  [218, 'ETIKET AMINI GOLD 20', 480250, 'lembar'],
  [219, 'ETIKET TABACO APEL SKT 12', 564100, 'lembar'],
  [220, 'Inner Black 75', 60, 'roll'],
  [221, 'Filter Capsule maanggo n grape mint', 40, 'pcs'],
  [222, 'Etiket Gass Poll Reguler 20', 1040000, 'lembar'],
  [223, 'Etiket Tab Duo Click 20', 277500, 'lembar'],
  [224, 'Etiket Jamas Filter SKM 10 Metalize', 512000, 'lembar'],
  [225, 'Etiket Amini Mojito Mango Metalize', 648000, 'lembar'],
  [226, 'INNER FRAME GREEN 96', 58, 'roll'],
  [227, 'CTP TAB DUO', 46, 'lembar'],
  [228, 'ETIKET MILLIONS MENTHOL20 EXPORT', 30000, 'lembar'],
  [229, 'ETIKET MILLIONS RED20 EXPORT', 92250, 'lembar'],
  [230, 'Box Polos one xport ( 510x300x480)', 20, 'pcs'],
  [231, 'Etiket Tabaco one lokal 12', 218000, 'lembar'],
  [232, 'CTP BALMAIN DYL', 28, 'lembar'],
  [233, 'Foil Gold 121', 70, 'roll'],
  [234, 'Foil Silver 121', 46, 'roll'],
  [235, 'Etiket Tabacco Gold', 47750, 'lembar'],
  [236, 'FOIL BLACK 66', 25, 'roll'],
  [237, 'Filter capsule double apple mango mint', 200, 'pcs'],
  [238, 'Dosspress millions mentol', 20000, 'pcs'],
  [239, 'Dosspress millions red', 21600, 'pcs']
]

/** Grid lembar kerja (baris judul + data) — bentuk yang sama dengan berkas .xlsx yang dibaca peramban. */
export const pdSampleGrid = (): (string | number)[][] => [[...PD_SAMPLE_HEADER], ...PD_SAMPLE_ROWS.map(row => [...row])]
